import { createContext, useContext } from "react";

interface PrivacyPreferencesContextValue {
  openPreferences: () => void;
}

export const PrivacyPreferencesContext = createContext<PrivacyPreferencesContextValue>({
  openPreferences: () => {},
});

export const usePrivacyPreferences = () => useContext(PrivacyPreferencesContext);
